import React from 'react'
import useAOS from '../shared/useAos';
import img1 from '../assets/images/Restaurant/WebP/1.webp'
import img2 from '../assets/images/ARNISI/WebP/1.webp'

export default function Banner3() {
    useAOS();

    return (
      <section
        className="p-5 overflow-hidden"  
        data-aos="fade-left"
        data-aos-delay="300"
        data-aos-duration="600"
      >
        <div className="mx-auto max-w-screen-2xl px-4 py-8 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {/* Left Column */}
            <div className="bg-blue-600 p-8 md:p-12 lg:px-16 lg:py-24">
              <div className="mx-auto max-w-xl text-left">
                <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-4xl font-bold text-white">
                Welcome to Arcium Studio
                </h2>
                <p className="mt-8 text-white/90">
                At Arcium Studio, we believe that great architecture is more than just structures—it’s about creating spaces that inspire, function beautifully, and stand the test of time. Our passion lies in designing environments that blend aesthetics with purpose, whether it’s a modern home, a commercial space, or a large-scale project. Explore our work, discover our approach, and stay inspired with insights into the latest architectural trends, innovative designs, and expert craftsmanship.📐 Let’s build something extraordinary together.                </p>
                <div className="mt-8">
                  <a
                    href="/services"
                    className="px-5 py-2.5 relative rounded-full group overflow-hidden font-medium bg-hover inline-block"
                  >
                    <span className="absolute top-0 left-0 flex w-full h-0 mb-0 transition-all duration-200 ease-out transform translate-y-0 bg-buttonHover group-hover:h-full opacity-90"></span>
                    <span className="relative text-color1 group-hover:text-white">
                      Learn More
                    </span>
                  </a>
                </div>
              </div>
            </div>
            {/* Right Column - Image Grid */}
            <div className="grid grid-cols-2 gap-4 md:grid-cols-1 lg:grid-cols-2">
              <img
                alt=""
                src={img1}
                className="w-full object-cover rounded-3xl h-full bg-blend-soft-light bg-buttonHover opacity-90 bg-cover"
              />
              <img
                alt=""
                src={img2}
                className="w-full object-cover rounded-3xl h-full"
              />
            </div>
          </div>
        </div>
      </section>
    );  
}
